var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("search", {
        attrs: { filters: _vm.filters, tags: _vm.tags },
        on: {
          searchType: function ($event) {
            return _vm.changeFilter($event)
          },
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.questions, function (question, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass:
              "row p-1 bg-white border-bottom d-flex align-items-center",
          },
          [_c("guest-question-card", { attrs: { question: question } })],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: { identifier: _vm.infiniteId },
          on: {
            distance: function ($event) {
              1
            },
            infinite: _vm.infiniteHandler,
          },
        },
        [
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }, [
            _vm._v(_vm._s(_vm.__("globals.no_questions_found_header"))),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }